export default {
  title: 'Vigtige noter',
  buttons: {
    add_note: 'Tilføj note',
  },
};
